import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import LinkButton from 'flarum/common/components/LinkButton';

/**
 * v0.19.02 — 侧边栏 nav 加「教务系统」入口 (辉哥 10/26 11:46)
 *
 * ## 根因 (老代码是**死代码**, 从未生效过)
 *   老代码 extend 的是 `IndexPage.prototype.navItems`, 但 **Flarum 2.0 的 `IndexPage`
 *   已经没有 `navItems()` 方法了** (vendor/flarum/core/js/src/forum/components/IndexPage.tsx
 *   里 grep -n "navItems" 零命中, 它只剩 `<IndexSidebar />`)。
 *   ⇒ 给一个不存在的原型方法打补丁 ⇒ 永远不会被调用 ⇒ **侧边栏里从来没有这个入口**。
 *
 * ## 正确扩展点 = `IndexSidebar.prototype.navItems`
 *   vendor/flarum/core/js/src/forum/components/IndexSidebar.tsx L74 定义了 `navItems()`;
 *   `flarum-tags` 就是这么加的 (vendor/flarum/tags/js/src/forum/addTagList.js L14)
 *   ⇒ 同一个扩展点一定能生效 (站上 aura 侧边栏里的「标签」就是那一行加出来的)。
 *
 * ## 为什么**不用改 aura** (本批最关键的红线)
 *   ziven-theme-aura/js/src/forum/buildElements.js 的 `renderNavItems()` =
 *   `new IndexSidebar().navItems()` ⇒ 主体 nav 全部来自 vendor 这个方法
 *   ⇒ 扩展自己 extend 它, **桌面侧边栏 `.App-sidebar-aura` 和移动端抽屉 `#drawer`
 *   两边自动都有** ⇒ aura 一行都不用碰 (也避开与另一 session 的 aura 部署冲突)。
 *
 * ## itemName 约定
 *   `items.add('zs-scheduler', …)` ⇒ core `listItems()` 渲染成 `<li class="item-zs-scheduler">`
 *   (core/js/src/common/helpers/listItems.tsx: `item-${item.itemName}`)。
 *
 * ## ⚠️ 为什么**还要**给 `itemClassName="item-zs-scheduler"` (brief §2.1 的代码片段漏了这一步)
 *   core `listItems()` 里 li 的 class = `item-${itemName}` **+** `attrs.itemClassName` 两个来源。
 *   而 ziven-theme-aura 的 `renderNavItems()` (buildElements.js L283-296) 对 **LinkButton 类**
 *   的 nav 项会**重新造一个 vnode**: `m(LinkButton, {key: item.itemName || …, ...item.attrs, active})`
 *   ⇒ **新 vnode 上没有 `itemName` 属性** ⇒ core 的 `item-${itemName}` 这一路**丢了**
 *   ⇒ aura 侧边栏 / 抽屉里这一项的 li **拿不到 `item-zs-scheduler` class**
 *   (实测: aura 的 nav 里所有 LinkButton 项的 li class 都是空的, 只有 item-tagN / item-aura-* 这类
 *    非 LinkButton 项才有 class)。
 *   ⇒ 补 `itemClassName="item-zs-scheduler"` (core 自己也是这么用的, 见
 *      `IndexSidebar.items()` 的 `itemClassName="App-primaryControl"`),
 *      它走 `attrs` 通道 ⇒ aura 重建 vnode 时被 `...item.attrs` 带走 ⇒ **两边都有这个 class**。
 *   ⛔ 副作用(无害): core 自己那个 header 下拉菜单里的 li 会变成
 *      `class="item-zs-scheduler item-zs-scheduler"` (itemName 一路 + itemClassName 一路, 同名)
 *      ⇒ 该下拉菜单宽度为 0、被 aura 收起来, 视觉上不可见。
 *
 * ## priority 90 = 主体 nav 第 2 项
 *   全部讨论(100) → **教务系统(90)** → 标签(70) → 分隔线(50) → 个人主页(40) → 设置(30) …
 *   (core ItemList.toArray() = 按 priority **降序** + 稳定排序 ⇒ 位置只由 priority 决定)
 */
export default function addSidebarMenu() {
  extend(IndexSidebar.prototype, 'navItems', function (items) {
    // ⚠️ 辉哥 10/26 12:01 拍板: 「教务系统」入口**只给登录用户看** (游客不显示)。
    //    判据必须放在 extend 回调**内部** —— 回调每次重建 nav 都会跑 ⇒ 准。
    //    ⛔ 不能放在「要不要注册 extend」那一层 (那是老代码的坑, 见 attachMenu.js 的注释)。
    if (!app.session.user) return items;
    items.add('zs-scheduler', m(LinkButton, {
      icon: "fas fa-graduation-cap",
      href: app.route('scheduler'),
      itemClassName: "item-zs-scheduler"
    }, app.translator.trans('ziven-scheduler.forum.nav-name')), 90);
    return items;
  });
}